<template>
  <b-select v-model="selectedValue"
            @input="updateValue"
            placeholder="placeholder"
            icon=""
            required
            >
    <optgroup v-if="isGroup" v-for="parent in items"
              :key="parent.groupLabel"
              :label="parent.groupLabel">
      <option v-for="item in parent.children"
              :key="item.value"
              :value="item.value">{{ item.label }}
      </option>
    </optgroup>
    <option v-else v-for="item in items"
            :key="item.value"
            :value="item.value">{{ item.label }}
    </option>
  </b-select>
</template>

<script>
export default {
  name: 'Selector',
  model: {
    prop: 'selectedValue',
    event: 'change'
  },
  props: {
    items: Array,
    isGroup: false,
    selectedValue: '',
    placeholder: String
  },
  methods: {
    updateValue (selectedValue) {
      this.$emit('change', selectedValue)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/inputs/Selector.vue